class Sort {
    constructor(element, form) {
        this.element = element
        this.form = form
        this.popup = $(this.element).find('.js-popup[data-popup-id=sort]')?.[0]?._popup
        this.button = $(this.element).find('.js-sort-button')
        this.init()
        this.initListeners()
    }

    init() {
        const sort = $(this.form).find('input[name=sort]').val()
        this.changeActiveSortByValue(sort)
    }

    initListeners() {
        $(this.element).find('input').on('click', this.handleSort.bind(this))
    }

    handleSort(event) {
        const target = $(event.target)
        this.changeActiveSortByValue(target.val())
        $(this.form).submit()
        this.popup.closePopup()
    }

    changeActiveSortByValue(value) {
        const label = $(this.element).find(`[value=${value}]`).closest('label')
        $(this.element).find('label').removeClass('active')
        $(this.button).find('span').html( 'Сортировать: ' + label.text().trim())
        $(this.form).find('[name=sort]').val(value)
        label.addClass('active')
    }
}